import * as React from 'react';
import { SVGProps } from 'react';

const IconHomeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 9V14.3a.7.7 0 0 0 .7.7H6v-5h4v5h2.3a.7.7 0 0 0 .7-.7V9h1.295c.616 0 .935-.761.513-1.226L8.513 1.23a.687.687 0 0 0-1.026 0L1.192 7.774C.77 8.239 1.089 9 1.705 9H3Z" />
  </svg>
);
export default IconHomeSizeS;
